import { Member } from "./member";
import { User } from "./user";

export interface ActivityChange {
    field: string;
    fieldLabel: string;
    oldValue: string;
    newValue: string;
}

export interface Activity {
    id?: string;
    name: string;
    userId: string;
    createdByUser?: User;
    createdByUserName?: string;
    note: string;
    changes?: string;
    isActive: boolean;
    createdAt?: Date;
}

export class ActivityFormValues {
    id?: string = undefined;
    name = '';
    userId = '';
    createdByUser?: User;
    createdByUserName?: string;
    note = '';
    changes?: string;
    isActive = true;
    createdAt = null;

    constructor(activity?: ActivityFormValues) {
        if (activity) {
            this.id = activity.id;
            this.name = activity.name;
            this.userId = activity.userId;
            this.createdByUser = activity.createdByUser;
            this.createdByUserName = activity.createdByUserName;
            this.note = activity.note;
            this.changes = activity.changes;
            this.isActive = activity.isActive;
            this.createdAt = activity.createdAt;
        }
    }
}

export class Activity implements Activity {
    constructor(init?: ActivityFormValues) {
        Object.assign(this, init);
    }
}
